@if (device) {
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        @if (!editMode) {
          <display-device-info class="col-lg-5 col-xl-12 mb-2 px-0" [device]="device"
            [userRoleLevel]="$safeNavigationMigration(user?.roleLevel)" [residentsLength]="$safeNavigationMigration(residents?.length)"
            (enterEditMode)="toggleEditMode()">
          </display-device-info>
        }
        @if (editMode) {
          <div class="col-lg-12">
            <form [formGroup]="devEditForm">
              <h5>{{ "EDIT_DEVICE_SETTINGS" | translate }}</h5>
              <div class="row">
                <div class="divider"></div>
                <div class="col-lg-3">
                  <h6>{{ "DEVICE_INFORMATION" | translate }}</h6>
                </div>
                <div class="col-lg-9">
                  <div class="form-group">
                    <label><strong>{{ "NAME" | translate }}</strong></label>
                    <input type="text" class="form-control" placeholder="{{ 'NAME' | translate }}"
                      formControlName="name" />
                    </div>
                    <div class="form-group">
                      <label><strong>{{ "DEVICE_ADDITIONAL_ALARM_INFO" | translate }}</strong></label>
                      <textarea class="form-control"
                        placeholder="{{ 'DEVICE_ADDITIONAL_ALARM_INFO' | translate }}"
                        formControlName="additionalAlarmInfo">
                      </textarea>
                    </div>
                    <div class="form-group">
                      <label><strong>{{ "DEVICE_ADDITIONAL_INFO" | translate }}</strong></label>
                      <textarea class="form-control"
                        placeholder="{{ 'DEVICE_ADDITIONAL_INFO' | translate }}"
                        formControlName="additionalInfo">
                      </textarea>
                    </div>
                  </div>
                </div>
                @if (residents?.length > 0) {
                  <div class="row">
                    <div class="divider"></div>
                    <div class="col-lg-3">
                      <h6>{{ "RESIDENT" | translate }}</h6>
                    </div>
                    <div class="col-lg-9">
                      <div class="form-group">
                        <label><strong>{{ "RESIDENT" | translate }}</strong></label>
                        <ngx-bootstrap-multiselect [options]="residentSelect.residentList"
                          [settings]="residentSelect.settings" [texts]="residentSelect.texts"
                          formControlName="deviceResidentId"
                        #selectedResident></ngx-bootstrap-multiselect>
                      </div>
                    </div>
                  </div>
                }
                @if (!device.basestationId || device.basestationId === '00000000') {
                  <div class="row">
                    <div class="divider"></div>
                    <div class="col-lg-3">
                      <h6>{{ "LOCATION" | translate }}</h6>
                    </div>
                    <div class="col-lg-9">
                      <div class="form-group">
                        <label><strong>{{ "LOCATION" | translate }}</strong></label>
                        <mat-form-field class="selector-full-width">
                          <mat-select formControlName="locationId">
                            @for (loc of locations; track loc) {
                              <mat-option [value]="loc.id">
                                {{ loc.name }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                }
                <!-- Display if device is Danalock/other lock and user is main user or admin-->
                @if (isLock() && user.roleLevel >= 100) {
                  <div class="row">
                    <div class="divider"></div>
                    <div class="col-lg-3">
                      <h6>{{ "LOCK_INFORMATION" | translate }}</h6>
                    </div>
                    <div class="col-lg-9">
                      <div class="form-group">
                        <label><strong>{{ "LOCK_SERIAL_NUMBER" | translate }}</strong></label>
                        <input type="text" class="form-control"
                          placeholder="{{ 'LOCK_SERIAL_NUMBER' | translate }}"
                          formControlName="lockSerialNumber" />
                        </div>
                        <div class="form-group">
                          <label><strong>{{ "LOCKED_DOOR_TYPE" | translate }}</strong></label>
                          <mat-form-field class="selector-full-width">
                            <mat-select formControlName="lockedDoorTypeID">
                              @for (type of lockedDoorTypes; track type) {
                                <mat-option [value]="type.value">
                                  {{ type.name | translate }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <!-- Show if door type is not Entry Door -->
                        @if (devEditForm.value.lockedDoorTypeID !== '1') {
                          <div class="row">
                            <div class="col-lg-6">
                              <div class="form-group">
                                <label><strong>{{ "ROOM_NUMBER" | translate }}</strong></label>
                                <input type="text" class="form-control"
                                  placeholder="{{ 'ROOM_NUMBER' | translate }}"
                                  formControlName="roomNumber" />
                                </div>
                              </div>
                              <div class="col-lg-6">
                                <div class="form-group">
                                  <label><strong>{{ "FLOOR_NUMBER" | translate}}</strong></label>
                                  <input type="text" class="form-control"
                                    placeholder="{{ 'FLOOR_NUMBER' | translate }}"
                                    formControlName="floorNumber" />
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      }
                      <div class="row">
                        <div class="divider"></div>
                        <div class="col-lg-3">
                          <h6>{{ "ADDRESS" | translate }}</h6>
                        </div>
                        <div class="col-lg-9">
                          <div class="form-group">
                            <label><strong>{{ "ADDRESS" | translate }}</strong></label>
                            <input type="text" class="form-control" placeholder="{{ 'ADDRESS' | translate }}"
                              formControlName="address" />
                            </div>
                            <div class="row">
                              <div class="col-lg-4">
                                <div class="form-group">
                                  <label><strong>{{ "POSTCODE" | translate}}</strong></label>
                                  <input type="text" class="form-control"
                                    placeholder="{{ 'POSTCODE' | translate }}" formControlName="postCode" />
                                  </div>
                                </div>
                                <div class="col-lg-8">
                                  <div class="form-group">
                                    <label><strong>{{ "POSTOFFICE" | translate }}</strong></label>
                                    <input type="text" class="form-control"
                                      placeholder="{{ 'POSTOFFICE' | translate }}"
                                      formControlName="postOffice" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Show only if specific pay to use features are enabled and conditions for child elements apply -->
                            @if ((!device.basestationId || device.basestationId === '00000000' || device.allSubClasses) && isFeatureEnabled('IotComms')) {
                              <div
                                class="row">
                                <div class="divider"></div>
                                <div class="col-lg-3">
                                  <h6>{{ "ADVANCED_SETTINGS" | translate }}</h6>
                                </div>
                                <!--Show only for top level devices-->
                                @if (!device.basestationId || device.basestationId === '00000000') {
                                  <div class="col-lg-9">
                                    <div class="form-group">
                                      <label><strong>{{ "EXTERNAL_IDENTIFIER" | translate }}</strong></label>
                                      <input type="text" class="form-control" formControlName="externalIdentifier" />
                                    </div>
                                    <div class="form-group">
                                      <label><strong>{{"EXTERNAL_PASSWORD" |translate}}</strong></label>
                                      <input type="text" class="form-control" formControlName="externalPassword" />
                                    </div>
                                    <!--If password is empty show button to generate new password-->
                                    <div class="form-group">
                                      @if (!devEditForm.value.externalPassword) {
                                        <button appThrottleClick
                                          (throttledClick)="generateExternalPassword()"
                                          class="btn btn-outline-primary gray-bg mr-1">
                                          <span class="fal fa-key"></span>
                                          {{ "GENERATE_PASSWORD" | translate }}
                                        </button>
                                      }
                                    </div>
                                  </div>
                                }
                                <!--Show only if there are sub classes for device-->
                                @if (device.allSubClasses) {
                                  <div class="col-lg-9">
                                    <div class="form-group">
                                      <label><strong>{{ "DEV_SUB_CLASS" | translate }}</strong></label>
                                      <mat-form-field class="selector-full-width">
                                        <mat-select formControlName="devSubClass">
                                          @for (subClass of device.allSubClasses; track subClass) {
                                            <mat-option
                                              [value]="subClass.devSubClass">
                                              {{ subClass.subClassDescription | subClassTranslationKey | translate }}
                                            </mat-option>
                                          }
                                        </mat-select>
                                      </mat-form-field>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                            <!-- Nightowl CustomerID select if customer has multiple IDs -->
                            @if (user.roleLevel >= 200 && isNightowlDevice() && customerIds.length > 1) {
                              <div class="row">
                                <div class="divider"></div>
                                <div class="col-lg-3">
                                  <h6>{{'NIGHTOWL_CUSTOMER_ID' | translate}}</h6>
                                </div>
                                <div class="col-lg-9">
                                  <div class="form-group">
                                    <label><strong>{{'NIGHTOWL_CUSTOMER_ID' | translate}}</strong></label>
                                    <mat-form-field class="selector-full-width">
                                      <mat-select formControlName="nightowlCustomerId">
                                        @for (customerId of customerIds; track customerId) {
                                          <mat-option [value]="customerId.id">
                                            {{ customerId.name ? customerId.name : customerId.id }}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                </div>
                              </div>
                            }
                            <div class="divider"></div>
                          </form>
                          <div class="form-group">
                            <button appThrottleClick (throttledClick)="submitDeviceEdit()"
                              [disabled]="devEditForm.invalid || devEditForm.pristine"
                              class="btn btn-outline-primary gray-bg mr-1">
                              <span class="fal fa-save"></span>
                              {{ "SAVE" | translate }}
                            </button>
                            <button type="reset" class="btn btn-outline-danger" (click)="resetForm(); toggleEditMode()">
                              <span class="fal fa-times"></span>
                              {{ "CANCEL" | translate }}
                            </button>
                          </div>
                        </div>
                      }
                      <!-- Edit device activation information -->
                      @if (!editMode) {
                        <div class="col-lg-7 col-xl-12 px-0">
                          @if (!activationsParsed) {
                            <img class="fadeLoader centerLoader logoSmall"
                              src="assets/img/loading_logo.svg" />
                          }
                          @if (activationsParsed) {
                            @if (activationsSaveError) {
                              <div class="alert alert-danger">
                                <span>{{ "CONFLICTING_ROUTES_ON_ACTIVATION" | translate }}</span>
                                <span><strong>{{ activationsSaveError }}</strong></span>
                              </div>
                            }
                            @if (activationsSaveSuccess) {
                              <div class="alert alert-success">
                                <span>{{ "DEVICE_ACTION_UPDATED" | translate }}: </span>
                                <span><strong>{{ activationsSaveSuccess }}</strong></span>
                              </div>
                            }
                            <form [formGroup]="activationEditForm">
                              <div class="card-borders mt-sm-4 mt-4 mt-lg-0">
                                <table class="table table-borderless table-responsive centerTableContent">
                                  <thead>
                                    <tr class="border-bottom">
                                      <th style="width: 45%">
                                        {{ "ACTIVATION" | translate }}
                                        <span matTooltip="{{ 'TOOLTIP_ACTIVATION' | translate }}"
                                        class="fa fa-fw fa-info-circle"></span>
                                      </th>
                                      <th style="width: 45%">
                                        {{ "ALARM_ROUTE" | translate }}
                                        <span matTooltip="{{ 'TOOLTIP_ALARM_ROUTE' | translate }}"
                                        class="fa fa-fw fa-info-circle"></span>
                                      </th>
                                      <th style="width: 9%"></th>
                                      <th style="width: 1%"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    @for (name of activationNames; track name; let i = $index) {
                                      <!-- Every activation dropdown has it's own formControlGroup, which are stored inside FormArray -->
                                      <tr class="border-top" [formGroup]="activationsFormArray.controls[i]">
                                        <td>{{ name }}</td>
                                        <td>
                                          <mat-form-field class="device-alarm-route-select">
                                            <!--  Show No Alarm Routes label if routeSelection is empty-->
                                            <!-- <mat-label *ngIf="routeSelection.empty">
                                            <span>{{ NO_ALARM_ROUTE" | translate }}</span>
                                          </mat-label> -->
                                          <mat-select formControlName="selectedRouteIds" #routeSelection
                                            placeholder="{{ routeSelection.empty ? ('NO_ALARM_ROUTE' | translate) : null}}"
                                            multiple>
                                            @for (alarmRouteLocation of availableAlarmRouteLocations; track alarmRouteLocation) {
                                              <mat-optgroup
                                                [label]="alarmRouteLocation.locationName">
                                                @for (route of getNonDefaultRoutes(alarmRouteLocation); track route) {
                                                  <mat-option
                                                    [value]="route.id">
                                                    {{ route.name }}
                                                  </mat-option>
                                                }
                                              </mat-optgroup>
                                            }
                                          </mat-select>
                                        </mat-form-field>
                                      </td>
                                      @if (user?.roleLevel >= 50) {
                                        <td colspan="2">
                                          @if (!routeSelection.empty) {
                                            <span [id]="'clearActivation' + i"
                                              class="fa-regular fa-fw fa-times fa-lg clear-routes-button d-inline pr-2"
                                            (click)="clearActivationRoutes(i)"></span>
                                          }
                                          @if (activationsFormArray.controls[i].dirty) {
                                            <span
                                              [id]="'saveActivation' + i"
                                              class="fas fa-fw fa-save fa-lg save-activation-button d-inline"
                                              (click)="submitActivationEdit(i)">
                                            </span>
                                          }
                                        </td>
                                      }
                                    </tr>
                                  }
                                </tbody>
                              </table>
                            </div>
                          </form>
                        }
                      </div>
                    }
                    <!-- Get masterlock temporary code -->
                    @if (!editMode && isMasterlock() && hasMasterlockCodeAccess()) {
                      <div class="col-lg-7 col-xl-12 px-0 mt-2" test-id="masterlock-access">
                        <ng-container>
                          <div class="card-borders mt-sm-4 mt-4 mt-lg-0">
                            <table class="table table-borderless table-responsive centerTableContent">
                              <thead>
                                <tr class="border-bottom">
                                  <th style="width: 45%">
                                    {{ "TEMPORARY_CODE" | translate }}
                                    <span matTooltip="{{ 'TOOLTIP_TEMP_CODE' | translate }}"
                                    class="fa fa-fw fa-info-circle"></span>
                                  </th>
                                  <th style="width: 45%"></th>
                                  <th style="width: 9%"></th>
                                  <th style="width: 1%"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container>
                                  <tr class="border-top">
                                    <td>
                                      <button appThrottleClick
                                        (throttledClick)="getTemporaryCode()"
                                        class="btn"
                                        [ngClass]= "temporaryCode?.combination ? 'btn-secondary' : 'btn-primary'"
                                        [disabled]="tempCodeButtonDisabled">
                                        {{ "GENERATE_CODE" | translate }}
                                      </button>
                                    </td>
                                    <td>
                                      <mat-card class="mat-elevation-z0 temp-code-card">
                                        @if (temporaryCode) {
                                          @if (temporaryCode.type === 'numeric') {
                                            <div class="icon-container-wrapper">
                                              @for (number of temporaryCode.combination.split(''); track number) {
                                                <div class="icon-container number-icon">
                                                  <span class="fa-stack fa-3x">
                                                    <strong class="fa-stack-1x">{{number}}</strong>
                                                  </span>
                                                </div>
                                              }
                                            </div>
                                          }
                                          @if (temporaryCode.type === 'arrows') {
                                            <div class="icon-container-wrapper">
                                              @for (letter of temporaryCode.combination.split(''); track letter) {
                                                <div class="icon-container">
                                                  <i [ngClass]="getArrowIcon(letter)"></i>
                                                </div>
                                              }
                                            </div>
                                          }
                                        }
                                      </mat-card>
                                    </td>
                                  </tr>
                                  <tr class="no-margin-top">
                                    <td></td>
                                    <td>
                                      @if (temporaryCode.validFrom && temporaryCode.validTo) {
                                        <span>
                                          {{ 'TEMP_CODE_VALID_ON' | translate: {
                                          date: temporaryCode.validFrom | date:'yyyy-MM-dd',
                                          fromTime: temporaryCode.validFrom | date:'HH:mm',
                                          toTime: temporaryCode.validTo | date:'HH:mm'
                                          } }}
                                        </span>
                                      }
                                    </td>
                                  </tr>
                                </ng-container>
                              </tbody>
                            </table>
                          </div>
                        </ng-container>
                      </div>
                    }
                  </div>
                  @if ( signalLevels?.length > 0 && user?.roleLevel === 200 && !editMode) {
                    <device-signal-levels class="row mt-3"
                      [signalLevels]="signalLevels" [networkSurveyResults]="networkSurveyResults"
                      [deviceType]="device.deviceType">
                    </device-signal-levels>
                  }
                </div>
              </div>
            }
            @if (!device) {
              <div class="row">
                <div class="col-lg-12">
                  <img class="fadeLoader centerLoader logoSmall" src="assets/img/loading_logo.svg" />
                </div>
              </div>
            }